import styled from 'styled-components';

import Icon, { LeftOutlined, RightOutlined } from '@ant-design/icons';

export const Container = styled.button(({ theme }) => ({
  position: 'absolute',
  top: 'calc(50% - 6rem)',
  background: 'transparent',
  paddingInline: 0,
  color: theme.palette.white,
  cursor: 'pointer',

  '&:not(:hover)': {
    border: 'none',
  },

  '&.left': {
    left: '0',
  },

  '&.right': {
    right: '0',
  },

  '&:hover': {
    width: '165rem',
    border: `1rem solid ${theme.palette.white}`,
    top: 'calc(50% - 90rem)',
  },

  '&:hover img': {
    display: 'block',
    width: '100%',
    height: '81rem',
  },

  '&:hover div': {
    backgroundColor: theme.palette.blackOlive,
  },

  '&:hover span': {
    display: 'inline-block',
  },
}));

export const InnerCarouselImage = styled.img({
  display: 'none',
});

export const InnerCarouselContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  backgroundColor: 'transparent',
  paddingBlock: '2rem',

  '&.right': {
    justifyContent: 'flex-end',
  },
});

export const InnerCarouselIcon = styled(Icon)({
  marginTop: '3rem',

  '&.left': {
    marginLeft: '2rem',
    order: 1,
  },

  '&.right': {
    marginRight: '2rem',
    order: 2,
  },
});

export const InnerCarouselSpan = styled.span({
  display: 'none',

  '&.left': {
    marginLeft: '10rem',
    order: 2,
  },

  '&.right': {
    marginRight: '10rem',
    order: 1,
  },
});

export const LeftArrow = styled(LeftOutlined)({
  fontSize: '24rem',
});

export const RightArrow = styled(RightOutlined)({
  fontSize: '24rem',
});
